var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-\\u2013-Assets-and-styles",
    transform: "translate(-1191.000000, -743.000000)",
    fill: "#DA291C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Icon",
    transform: "translate(1191.000000, 743.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fillRule: "evenodd",
    points: "9 9 11.999625 9 11.999625 0 9 0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 10.5,
    width: 12,
    height: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fillRule: "evenodd",
    points: "4.5 9 7.5 9 7.5 2.25 4.5 2.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fillRule: "evenodd",
    points: "0 9 3 9 3 4.5 0 4.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ee846235515b55b0d2bdc3618bb8af12.svg";
export { ForwardRef as ReactComponent };